var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card wrapper",on:{"click":_vm.toggleBase}},[_c('div',{staticClass:"symbol"},[_vm._v(_vm._s(_vm.symbol))])])
}
var staticRenderFns = []

export { render, staticRenderFns }